import { render, staticRenderFns } from "./CustomerPartnersShareholders.vue?vue&type=template&id=79677298"
import script from "./CustomerPartnersShareholders.vue?vue&type=script&lang=js"
export * from "./CustomerPartnersShareholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports